import apiClient from './ApiInterceptor';

export const fetchCategories = async (branch) => {
    try {
        const params = {};
        if (branch) {
            params.branch = branch;
        }

        const response = await apiClient.get('/categories', { params });
        return response.data;
    } catch (error) {
        console.error('CategoriesApi - fetchCategories, Error fetching data:', error);
    }
};
